
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';

import on from 'dojo/on';

import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import EvTaskMatrix_ConfigSelector from './EvTaskMatrix_ConfigSelector';
import { AddressTypes } from "../../_loadingHelpers/Address";
import _MatrixManagerBase from '../../../moreCore/UI/Matrix/_MatrixManagerBase';

class EvTaskMatrix extends compose(_MatrixManagerBase<AddressTypes.AddressEntity_Base, EvTask, any>) {

    protected onCallConfiguration(): boolean {

        // hier eine wie auch immer geartete Konfigurationsmöglichkeit starten:
        let selector = new EvTaskMatrix_ConfigSelector();

        let dlg = new GenericDialog();

        dlg.enableContentOverflow(true);

        dlg.setup({
            header: "OM_Matrix__ChooseYourParameters",
            content: selector.domNode,
            buttonPreset: "okcancel",
            size: "smaller",
            callback: lang.hitch(this, this._onConfigSelection, selector),
            distinctiveNoCallback: "silentclose",
            closeOnEnter: true,
            closeOnEscape: true,
        });
        dlg.disableButton("ok");

        on(selector, "valid", lang.hitch(this, function (dlg, flag) { dlg.enableButton("ok", !!flag); }, dlg));

        selector.startup();
        

        // inzwischen der Matrix zurückmelden dass wir dran sind:
        return true;
    }

    private _lastConfigData;
    private _onConfigSelection(selector: MdsLax<InstanceType<typeof EvTaskMatrix_ConfigSelector>>, result) {
        let data = selector.getData();
        this._lastConfigData = data;

        this.setup({
            configurationAPI: "Webtool_API_EvTaskMatrix__LoadConfiguration",
            contentAPI: "Webtool_API_EvTaskMatrix__LoadGridContent",
            configurationParams: lang.hitch(this, this.getRequestData),
            saveAPI: "Webtool_API_EvTaskMatrix__CommitContent",
            cellClickCheck: lang.hitch(this, this._checkCellClickAllowed)
        });
    }

    private getRequestData(): Object {
        let data = this._lastConfigData;
        return data;
    }

    private _checkCellClickAllowed(x: AddressTypes.AddressEntity_Base, y: EvTask, z: any): boolean {
        console.debug(this.id + " _checkCellClickAllowed", x, y, z);
        return true;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        this.setTitles("EvTaskMatrix__MainTitle");
    }
}

export default mdsWidget(EvTaskMatrix);